import React from 'react';
import { HomePage } from '../components/home';
import Layout from '../components/layout';
import SEO from '../components/seo';

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Carvana Help & Support" />
      <HomePage />
    </Layout>
  );
};

export default IndexPage;
